import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Chip from 'components/common/chip';

const TeamButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const TeamButton = styled(Chip)`
  margin-top: ${p => p.theme.spacing.stackMedium};
  margin-right: ${p => p.theme.spacing.inlineSmall};
`;

export default function UserEditorTeamList({ teams }) {
  const className = 'userEditor-teams';
  return (
    <div className={className}>
      <div className={`${className}-header`}>
        <div className={`${className}-title`}>Teams</div>
      </div>
      <TeamButtonsContainer>
        {teams && teams.length > 0 ? (
          teams.map(renderTeamButton)
        ) : (
          <div className={`${className}-noTeamAssigned`}>No team assigned</div>
        )}
      </TeamButtonsContainer>
    </div>
  );

  function renderTeamButton(teamName) {
    return <TeamButton data-aid={`${className}-button`} label={teamName} key={teamName} />;
  }
}

UserEditorTeamList.propTypes = {
  teams: PropTypes.arrayOf(String),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor_team_list.jsx